/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React from 'react';

const UpcomingInterviewsPanel = ({ interviews = [] }) => {
  const safeInterviews = Array.isArray(interviews) ? interviews : [];
  const hasInterviews = safeInterviews.length > 0;

  const formatDate = (interview) => {
    const date =
      interview?.interview_local_start ||
      interview?.interview_local_date ||
      (interview?.interview_date
        ? new Date(interview.interview_date)
        : null);

    if (!date || Number.isNaN(date.getTime?.())) {
      return { day: '--', month: '' };
    }

    return {
      day: String(date.getDate()).padStart(2, '0'),
      month: date.toLocaleDateString('en-US', { month: 'short' })
    };
  };

  const formatTimeRange = (interview) => {
    const { interview_start_time: start, interview_end_time: end, interview_time } = interview || {};
    const startValue = start || interview_time;

    const toDisplay = (value) => {
      if (!value) return '';
      if (!value.includes(':')) return value;
      const parsed = new Date(`1970-01-01T${value}`);
      if (Number.isNaN(parsed.getTime())) return value;
      return parsed.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    };

    const startFormatted = toDisplay(startValue);
    const endFormatted = toDisplay(end);

    if (startFormatted && endFormatted) return `${startFormatted} - ${endFormatted}`;
    return startFormatted || endFormatted || 'Time TBD';
  };

  return (
    <div className="upcoming-interviews-panel card">
      <div className="card-header">
        <h3>
          <i className="fas fa-calendar-alt" />
          Upcoming Interviews
        </h3>
      </div>

      <div className="card-body">
        {hasInterviews ? (
          <ul className="upcoming-interviews-list">
            {safeInterviews.slice(0, 5).map((interview, index) => {
              const { day, month } = formatDate(interview);

              return (
                <li
                  key={`${interview?.id || interview?._id || index}`}
                  className="upcoming-interview-item"
                >
                  <div className="interview-details">
                    <div className="interview-candidate-name">
                      {interview?.applicant_name || interview?.candidate_name || 'Candidate'}
                    </div>
                    <div className="interview-job-title">
                      {interview?.job_title || interview?.interview_title || 'Interview'}
                    </div>
                    <div className="interview-time-mode">
                      <i className="fas fa-clock" />
                      {formatTimeRange(interview)}
                      {interview?.interview_mode && (
                        <span className="interview-mode-badge">{interview.interview_mode}</span>
                      )}
                    </div>
                  </div>
                  <div className="interview-date-badge">
                    <span className="date-day">{day}</span>
                    <span className="date-month">{month}</span>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="empty-state-small">
            <i className="fas fa-calendar-check" />
            <p>No upcoming interviews</p>
            <small>Scheduled interviews will appear here.</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpcomingInterviewsPanel;

